import React from 'react'

import chatImg from './assets/lawyer-chat.svg'
import contactImg from './assets/lawyer-contact.svg'
import docImg from './assets/lawyer-docs.svg'
import noteImg from './assets/lawyer-note.svg'

export enum Tabs {
  Contact,
  Note,
  Documents,
  Messages
}

export function MobileNavigation({ activeTab, clickHandler }) {
  const navigation = [
    {
      title: 'Kontakt',
      tab: Tabs.Contact,
      src: contactImg
    },
    {
      title: 'Aktennotiz',
      tab: Tabs.Note,
      src: noteImg
    },
    {
      title: 'Dokumente',
      tab: Tabs.Documents,
      src: docImg
    },
    {
      title: 'Nachrichten',
      tab: Tabs.Messages,
      src: chatImg
    }
  ]

  return (
    <nav className='lawyer-client-navigation'>
      <ul>
        {navigation.length > 0 &&
          navigation.map((item) => (
            <li
              key={item.title}
              className={activeTab === item.tab ? 'active' : ''}
              onClick={clickHandler.bind(null, item.tab)}
            >
              <svg
                width='54'
                height='54'
                version='1.1'
                xlinkHref='http://www.w3.org/1999/xlink'
                xmlns='http://www.w3.org/2000/svg'
              >
                <filter id='grayscale'>
                  <feColorMatrix type='saturate' values='0' />
                </filter>

                {activeTab === item.tab ? (
                  <image width='100%' height='100%' xlinkHref={item.src} />
                ) : (
                  <image filter='url(#grayscale)' width='100%' height='100%' xlinkHref={item.src} />
                )}
              </svg>

              <p>{item.title}</p>
            </li>
          ))}
      </ul>
    </nav>
  )
}
